import * as React from "react";
import { forwardRef } from "react";
const SvgX = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 15 15", style: {
  enableBackground: "new 0 0 15 15"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("polygon", { points: "13.9,1.2 13.3,0.6 7.3,6.7 1.2,0.6 0.6,1.2 6.7,7.3 0.6,13.3 1.2,13.9 7.3,7.9 13.3,13.9 13.9,13.3 7.9,7.3 " }));
const ForwardRef = forwardRef(SvgX);
export { ForwardRef as ReactComponent };
